import React from "react";
import Icon from "../../components/Icon";
import { Avatar, Button, Card, Empty, SkeletonRows } from "../../components/primitives";
import { ERR_TEXT } from "./manageUtils";
import useApplications from "./useApplications";

/** Applications tab (logic in useApplications). */
export default function ApplicationsTab({ club }) {
  const { state, apps, selected, bulkBusy, allSelected, toggle, toggleAll, act, bulk, retry } = useApplications(club);

  if (state.loading) return <SkeletonRows rows={4} />;
  if (state.error) {
    return (
      <Empty icon="alert" title="Couldn't load applications">
        <div>{ERR_TEXT}</div>
        <Button size="sm" style={{ marginTop: 10 }} onClick={retry} data-testid="manage.applications.retry">Retry</Button>
      </Empty>
    );
  }
  if (apps.length === 0) return <Empty icon="userplus" title="No pending applications">New applications show up here.</Empty>;

  return (
    <>
      <Card pad className="row wrap" style={{ marginBottom: 12 }}>
        <button type="button" className="row" onClick={toggleAll} data-testid="manage.applications.selectAll">
          <span className={`check ${allSelected ? "on" : ""}`}>{allSelected && <Icon name="check" size={14} />}</span>
          <b>{allSelected ? "Deselect all" : "Select all"}</b>
        </button>
        <span className="meta grow">{selected.size} selected</span>
        <Button variant="ok" size="sm" disabled={!selected.size || bulkBusy} onClick={() => bulk("approve")} data-testid="manage.applications.approveAll">Approve all</Button>
        <Button variant="danger" size="sm" disabled={!selected.size || bulkBusy} onClick={() => bulk("reject")} data-testid="manage.applications.denyAll">Deny all</Button>
      </Card>
      <div className="col">
        {apps.map((a) => (
          <Card key={a.id} pad className="row wrap">
            <button type="button" aria-label={`Select ${a.user?.full_name || "applicant"}`} aria-pressed={selected.has(a.id)} onClick={() => toggle(a.id)} data-testid={`manage.applications.row.${a.id}.select`}>
              <span className={`check ${selected.has(a.id) ? "on" : ""}`}>{selected.has(a.id) && <Icon name="check" size={14} />}</span>
            </button>
            <Avatar name={a.user?.full_name} url={a.user?.avatar_url} id={a.userId} size={46} />
            <div className="grow" style={{ minWidth: 180 }}>
              <b>{a.user?.full_name || `User ${String(a.userId || "").slice(0, 8)}`}</b>
              <div className="meta">{a.user?.email || "No email"}</div>
              <div className="meta">{a.user?.major || "No major"} · {a.user?.graduation_year || "No year"} · Applied {a.created_at_formatted || "Unknown date"}</div>
              {a.application_message ? <div className="meta" style={{ marginTop: 4, fontStyle: "italic" }}>{a.application_message}</div> : null}
              <b className="tiny" style={{ color: "var(--amberText)", textTransform: "capitalize" }}>{a.status || "pending"}</b>
            </div>
            <Button variant="ok" size="sm" disabled={bulkBusy} onClick={() => act(a.id, "approve")} data-testid={`manage.applications.row.${a.id}.approve`}>Approve</Button>
            <Button variant="danger" size="sm" disabled={bulkBusy} onClick={() => act(a.id, "reject")} data-testid={`manage.applications.row.${a.id}.deny`}>Deny</Button>
          </Card>
        ))}
      </div>
    </>
  );
}
